import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { cloneDeep, isEqual, orderBy, uniq } from 'lodash';
import { Observable, Subject, catchError, distinctUntilChanged, forkJoin, interval, map, of, takeUntil, takeWhile } from 'rxjs';
import { FileTypesDeleteMapper } from '../../form-data/post-data';
import {
  FileTypes,
  IFile,
  Microsoft_Empty_Blob_Contents,
  PreviewDocTypes,
  SaaSTokenParam,
  allowedExtensions,
  excludedExtensions,
} from '../../interfaces/referral.interface';
import {
  DocumentsSpace,
  PostsSpace,
  SortOrderDetail,
  User,
  WeavyData,
} from '../../interfaces/space.interface';
import { CollaborationService } from '../../services/collaboration.service';
import { SocketService } from '../../services/socket.service';
import { CreateFileDialogComponent } from '../create-file-dialog/create-file-dialog.component';
import { EditFileDialogComponent } from '../edit-file-dialog/edit-file-dialog.component';
import { FileDetailsDialogComponent } from '../file-details-dialog/file-details-dialog.component';
import { NoteComponent } from '../note/note.component';
import { SnackbarComponent } from '../snackbar/snackbar.component';
// import MsgReader from '@kenjiuno/msgreader'
import * as MsgReader from 'wl-msg-reader';
import { MSGFileData } from 'wl-msg-reader';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { UnAuthorizedComponent } from '../un-authorized/un-authorized.component';
import { NotificationSettingsComponent } from '../notification-settings/notification-settings.component';
import { NgClass, NgStyle, AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MatCard, MatCardActions } from '@angular/material/card';
import { MatIconButton, MatFabButton } from '@angular/material/button';
import { DocViewerComponent } from '../doc-viewer/doc-viewer.component';
import { SizePipe } from '../../pipes/size.pipe';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrl: './documents.component.scss',
    imports: [UnAuthorizedComponent, NotificationSettingsComponent, NgClass, MatTooltip, MatMenuTrigger, MatMenu, MatMenuItem, MatIcon, MatProgressBar, SpinnerComponent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgStyle, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatCard, MatCardActions, MatIconButton, MatFabButton, DocViewerComponent, AsyncPipe, UpperCasePipe, DatePipe, SizePipe, AssetUrlPipe]
})
export class DocumentsComponent implements OnInit, OnDestroy {
  @ViewChild('fileUpload') fileUpload!: ElementRef;
  @Input() weavyData!: WeavyData;
  @Input() docType!: any;
  @Input() downloadAdditionalDocsInput!: EventEmitter<any>;
  fileSpaceID: any;
  fileAppID: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  appName!: string;
  colRef: string[] = [];
  fileCreateMenuOpened = false;
  filePreUrls: any = {
    docx: 'ms-word:ofe%7cu%7c',
    xlsx: 'ms-excel:ofe%7cu%7c',
    pptx: 'ms-powerpoint:ofe%7cu%7c',
  };
  extensionFiletTypes = [
    'document',
    'image',
    'docx',
    'pptx',
    'png',
    'jpeg',
    'xlsx',
  ];
  selectedFileToView: any = '';
  selectedFileIndexToView: any = '';
  selectedFileDetails: any = {
    name: 'test1',
    type: 'application',
    kind: 'note',
    size: '10kb',
    modified: 'Modified 8/12/2024 5:55 PM by Lakshmi Tejasri Anantha',
  };
  actionMenuList = [
    {
      name: 'details',
      displayName: 'Details',
      imgUrl: 'info',
      menuItemClasses: 'icon-mr-5',
      isFolderAction: true,
    },
    {
      name: 'edit',
      displayName: 'Edit',
      imgUrl: 'pencil',
      menuItemClasses: 'icon-mr-5',
      fileOwnerOnly: true
    },
    {
      name: 'rename',
      displayName: 'Rename',
      imgUrl: 'textbox',
      menuItemClasses: 'icon-mr-5',
      isFolderAction: true,
      fileOwnerOnly: true
    },
    // {
    //   name: "share",
    //   displayName: "Share",
    //   imgUrl: "share",
    //   menuItemClasses: "icon-mr-5",
    //   isFolderAction: true
    // },
    // {
    //   name: "star",
    //   displayName: "Star",
    //   imgUrl: "star",
    //   isFolderAction: true
    // },
    // {
    //   name: "tags",
    //   displayName: "Tags",
    //   imgUrl: "tag",
    //   menuItemClasses: "icon-mr-5"
    // },
    {
      name: 'trash',
      displayName: 'Trash',
      imgUrl: 'trash',
      menuItemClasses: 'icon-mr-5',
      isFolderAction: true,
      fileOwnerOnly: true
    },
  ];

  subscribeActions = {
    subscribe: {
      name: 'subscribe',
      displayName: 'Subscribe',
      imgUrl: 'bell',
    },
    unsubscribe: {
      name: 'unsubscribe',
      displayName: 'Unsubscribe',
      imgUrl: 'bell_cross',
      menuItemClasses: 'icon-green',
    },
  };
  destroy$: Subject<boolean> = new Subject<boolean>();
  downloadAction = {
    name: 'download',
    displayName: 'Download',
    imgUrl: 'download',
    menuItemClasses: 'icon-mr-5',
  };

  fileTypesMapper: any = {
    docx: {
      menuOptions: [
        {
          name: 'office',
          dialogTitle: 'New Word document',
          displayName: 'Open in Word',
          imgUrl: 'word_file',
          url: 'https://chubbnet-services-dev.chubb.com/sharepoint/api/download/41016.doc',
        },
      ],
    },
    pptx: {
      menuOptions: [
        {
          name: 'office',
          dialogTitle: 'New Powerpoint document',
          displayName: 'Open in Powerpoint',
          imgUrl: 'ppt_file',
        },
      ],
    },
    xlsx: {
      menuOptions: [
        {
          name: 'office',
          dialogTitle: 'New Excel document',
          displayName: 'Open in Excel',
          imgUrl: 'excel_file',
        },
      ],
    },
    note: {
      menuOptions: [],
    },
    folder: {
      menuOptions: [],
    },
    pdf: {
      menuOptions: [],
    },
    eml: {
      menuOptions: [],
    },
    zip: {
      menuOptions: [],
    },
    png: {
      menuOptions: [],
    },
    jpg: {
      menuOptions: [],
    },
    txt: {
      menuOptions: [],
    },
  };
  fileTypesDeleteMapper: any = FileTypesDeleteMapper;
  menuList: any = [];
  menuItem: any = '';
  fileTypes: any = {
    docx: '.docx',
    xlsx: '.xlsx',
    pptx: '.pptx',
    folder: 'folder',
  };
  imageMapper: any = {
    docm: 'word_file',
    docx: 'word_file',
    doc: 'word_file',
    msg: 'email',
    pptx: 'ppt_file',
    ppt: 'ppt_file',
    xlsx: 'excel_file',
    xlsm: 'excel_file',
    xlsb: 'excel_file',
    xlss: 'excel_file',
    xls: 'excel_file',
    csv: 'excel_file',
    note: 'file_document',
    pdf: 'pdf',
    zip: 'zip',
    eml: 'email',
    png: 'image_png',
    jpg: 'image_png',
    svg: 'image_png',
    txt: 'text_grey',
    folder: 'folder',
  };
  draggedOver: boolean = false;
  progressVal: number = 0;
  showProgress: boolean = false;
  previewElement: any;
  tableView = true;
  showLoader = false;
  originalFilesData: IFile[] = [];
  breadcrumb: any;
  currentBreadcrumbId: any;
  currentBreadcrumbTableData: any;
  noData!: Observable<boolean>;
  isLoading: boolean = false;
  disableDragAndDrop: boolean = false;
  extensionMapper: any = {
    txt: 'text file',
    xls: 'spreadsheet',
    xlsx: 'spreadsheet',
    xlsm: 'spreadsheet',
    xlsb: 'spreadsheet',
    xlss: 'spreadsheet',
    doc: 'document',
    docx: 'document',
    pdf: 'document',
    ppt: 'presentation',
    pptx: 'presentation',
    jpg: 'image',
    svg: 'image',
    jpeg: 'image',
    png: 'image',
    zip: 'archive',
    '7zip': 'archive',
    eml: 'email',
    msg: 'email',
  };
  loggedUser!: User;
  documentSpaceDetails!: DocumentsSpace;
  appActionsList: any = [
    // {
    //   name: "share",
    //   displayName: "Share",
    //   imgUrl: "share",
    //   menuItemClasses: "icon-mr-5",
    //   isFolderAction: true
    // },
    // {
    //   name: "star",
    //   displayName: "Star",
    //   imgUrl: "star",
    //   isFolderAction: true
    // },
    // {
    //   name: "subscribe",
    //   displayName: "Subscribe",
    //   imgUrl: "bell",
    // },
    this.downloadAction,
  ];

  sortOrderDetail!: SortOrderDetail;
  columnMapper: any = {
    name: 'fileName',
    type: 'kind',
    date: 'createdAt',
    size: 'blobSize',
  };
  ihubMaximizeFlag: boolean = false;
  isUserUnAuthorized = false;
  errorStatusCode;
  createObjectURL = '';
  isApplicationRunningOnOnItSystem = false;
  displayName = "Files";
  maxFileSize: number = 25 * 1024 * 1024;
  bulkFileSize: number = 40 * 1024 * 1024;
  constructor(
    public matDialog: MatDialog,
    private snackBar: MatSnackBar,
    public collaborationService: CollaborationService,
    public socketService: SocketService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.isApplicationRunningOnOnItSystem =
      this.collaborationService.isApplicationRunningOnOnItSystem;
    this.breadcrumb = [];
    this.colRef = ['doc', 'name', 'date', 'type', 'size', 'actions'];
    if (this.weavyData?.isMobileScreen) {
      this.colRef = ['doc', 'name', 'actions'];
    }
    this.collaborationService.maximizeFlag.pipe(distinctUntilChanged((prev, curr) => isEqual(prev, curr)), takeUntil(this.destroy$)).subscribe((val: boolean) => {
      if (this.weavyData?.isIhubScreen) {
        this.ihubMaximizeFlag = val;
        if (val) {
          this.colRef = ['doc', 'name', 'date', 'type', 'size', 'actions'];
        } else {
          this.colRef = ['doc', 'name', 'actions'];
        }
      }
    });
    this.noData = this.dataSource
      .connect()
      .pipe(map((data: any) => data.length === 0));
    this.sortOrderDetail =
      this.docType === 'referral'
        ? this.collaborationService.referralDocumentsSortingDetails
        : this.collaborationService.policyDocumentsSortingDetails;
    this.menuList = Object.keys(this.fileTypesMapper).map((fileType: any) => {
      const download =
        [FileTypes.NOTE, FileTypes.FOLDER].includes(fileType) || this.weavyData?.isMobileScreen
          ? []
          : [this.downloadAction];
      return {
        type: fileType,
        list: [
          ...(this.fileTypesMapper[fileType]
            ? this.fileTypesMapper[fileType].menuOptions
            : []),
          ...download,
          ...(fileType === FileTypes.FOLDER
            ? this.actionMenuList.filter((list) => list.isFolderAction)
            : this.actionMenuList),
        ],
      };
    });
    this.showLoader = true;
    const spaceId =
      window.location.href.split('spaceId=')[1] ?? '66bca7c96a4c4c744b4ef92d';
    this.socketService.spaceId = spaceId;
    //this.listenToSocketConnection();
    // this.renderer.listen(
    //   'window',
    //   'collaborationPayloadData',
    //   (event: CustomEvent) => {
    //     this.zone.run(() => {
    //       this.socketService.spaceId = event.detail.payload.spaceId;
    //       this.listenToSocketConnection();
    //     });
    //   }
    // );

    // this.socketService.allDocuments.subscribe((res: any) => {
    //   console.log("handle all res", JSON.parse(res?.result?.body ?? '{}'));
    //   this.handelAllTopicEvents(res);
    // });
    // window.addEventListener('beforeunload', () => {
    //   this.socketService.unsubscribeFromTopics(this.socketService.allDocumentsSubscriptions);
    // });
    this.getDocumentsList();
  }

  listenToSocketConnection() {
    if (this.socketService.allDocumentsSubscriptions.length > 0) {
      this.socketService.unsubscribeFromTopics(
        this.socketService.allDocumentsSubscriptions
      );
    }
    this.socketService.isSocketConnected.subscribe({
      next: (res: any) => {
        if (res) {
          setTimeout(() => {
            this.socketService.getAllDocuments();
          }, 1000);
        } else {
          this.showLoader = true;
        }
      },
    });
  }

  openActions(index: number, element: IFile, event: any) {
    event.stopPropagation();
    this.selectedFileToView = element;
    this.selectedFileIndexToView = index;
    const resp = this.menuList.find((val: any) => val.type === element.kind);
    // subscribe and unsubscribe code commented
    // if (resp) {
    //   let insertIndex = resp.list.length - 1;
    //   if (resp.list.find((menu: any) => ['unsubscribe', 'subscribe'].includes(menu.name))) {
    //     resp.list[insertIndex - 1] = element.contentFollowed ?
    //       this.subscribeActions.unsubscribe :
    //       this.subscribeActions.subscribe;
    //   }
    //   else {
    //     element.contentFollowed ?
    //       resp.list.splice(insertIndex, 0, this.subscribeActions.unsubscribe) :
    //       resp.list.splice(insertIndex, 0, this.subscribeActions.subscribe);
    //   }
    // }
    this.menuItem = cloneDeep(resp);
    if (!this.menuItem) {
      const downloadAction = this.weavyData?.isMobileScreen
        ? []
        : [this.downloadAction];
      const newMenuItem: any = {
        type: element.kind,
        list: [...downloadAction, ...this.actionMenuList],
      };
      let insertIndex = newMenuItem.list.length - 1;
      // subscribe and unsubscribe code commented
      // if (newMenuItem.list.find((menu: any) => ['unsubscribe', 'subscribe'].includes(menu.name))) {
      //   newMenuItem.list[insertIndex - 1] = element.contentFollowed ?
      //     this.subscribeActions.unsubscribe :
      //     this.subscribeActions.subscribe;
      // }
      // else {
      //   element.contentFollowed ?
      //     newMenuItem.list.splice(insertIndex, 0, this.subscribeActions.unsubscribe) :
      //     newMenuItem.list.splice(insertIndex, 0, this.subscribeActions.subscribe);
      // }
      this.menuList.push(newMenuItem);
      this.menuItem = cloneDeep(newMenuItem);
    }
    this.menuItem.list = element.createdBy === this.loggedUser.id ? this.menuItem.list : this.menuItem.list.filter(ele => !ele.fileOwnerOnly);
    if (element.kind === 'note' && element.createdBy !== this.loggedUser.id) {
      this.menuItem.list.push({
        name: 'edit',
        displayName: 'Edit',
        imgUrl: 'pencil',
        menuItemClasses: 'icon-mr-5',
        fileOwnerOnly: true
      });
    }
  }

  view(action: any, isApp?: boolean) {
    switch (action.name) {
      case 'rename':
        this.renameFile();
        break;
      case 'trash':
        this.deleteFile();
        break;
      case 'download':
        isApp
          ? this.downloadAllFiles()
          : this.downloadOrOpenDocumentInDevice(action);
        break;
      case 'office':
        const openUrl = `${this.filePreUrls[this.menuItem.type]}${this.selectedFileToView?.url
          }${SaaSTokenParam}`;
        this.downloadOrOpenDocumentInDevice(action, openUrl);
        break;
      case 'edit':
        if (this.selectedFileToView.kind !== FileTypes.NOTE) {
          this.editFile();
        } else {
          this.createNote(this.selectedFileToView);
        }
        break;
      case 'details':
        this.fileDetails();
        break;
      case 'subscribe':
        this.followUnfollow(isApp);
        break;
      case 'unsubscribe':
        this.followUnfollow(isApp);
        break;
    }
  }

  editFile() {
    this.matDialog
      .open(EditFileDialogComponent, {
        data: {
          element: this.selectedFileToView,
          isMobileScreen: this.weavyData?.isMobileScreen
        },
        maxHeight: '90vh',
        width: '90vw',
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (value: any) => {
          this.editFileCheck(value);
        },
      });
  }
  async editFileCheck(value){
    if (value) {
      this.showLoader = true;
      const fileContent = value.file
        ? await this.collaborationService.getBase64File(value.file)
        : null;
      let lastDotIndex = value.file
        ? value.file.name.lastIndexOf('.')
        : -1;
      let fileType =
        lastDotIndex === -1
          ? ''
          : value.file.name.substring(lastDotIndex + 1);

      let newFile: any = {
        parentId: this.selectedFileToView.parentId,
        appId: this.fileAppID,
        spaceId: this.fileSpaceID,
        contentId: this.selectedFileToView.id,
        name: value.file?.name ?? value.fileName,
        createdAt: this.selectedFileToView.createdAt,
        createdBy: this.selectedFileToView.createdBy,
        modifiedAt: new Date().toISOString(),
        modifiedBy: this.loggedUser.id,
        blobId: this.selectedFileToView.blobId,
        blobName: value.file?.name ?? value.fileName,
        blobMediaType:
          value.file?.type ?? this.selectedFileToView.blobMediaType,
        blobSize: value.file?.size ?? this.selectedFileToView.blobSize,
        blobCreatedAt: fileContent
          ? new Date().toISOString()
          : this.selectedFileToView.blobCreatedAt,
        blobCreatedBy: fileContent
          ? this.loggedUser.id
          : this.selectedFileToView.blobCreatedBy,
        fileContent: fileContent,
        kind: fileContent
          ? this.extensionMapper[fileType]
          : this.selectedFileToView.kind,
        fileExtension: fileContent
          ? fileType
          : this.selectedFileToView.fileExtension,
        properties: JSON.stringify({
          Description: value?.description ?? '',
        }),
        tags: value.tags ? value.tags.join(',') : '',
      };

      this.collaborationService
        .updateDocument(this.fileSpaceID, this.fileAppID, newFile)
        .subscribe({
          next: (response: any) => {
            this.originalFilesData = this.updateFileDetails(
              this.originalFilesData,
              response,
              fileType
            );
            this.dataSource.data = this.updateFileDetails(
              this.dataSource.data,
              response,
              fileType
            );
            this.showLoader = false;
            this.collaborationService.displaySuccessMessage(
              'File updated successfully.'
            );
          },
          error: (err: any) => {
            this.showLoader = false;
            this.collaborationService.displayErrorMessage(
              err,
              'Error updating the file. Please try again after some time.'
            );
          },
        });
    }
  }
  updateFileDetails = (fileList: any[], response: any, fileType: any) => {
    return fileList.map((file) => {
      if (file.id === response.id) {
        if (!fileType) {
          let lastDotIndex = file.name.lastIndexOf('.');
          fileType =
            lastDotIndex === -1 ? '' : file.name.substring(lastDotIndex + 1);
          response.blobSize = file.blobSize;
        }
        return {
          ...response,
          fileName: response.name,
          fileExtension: fileType,
        };
      }
      return file;
    });
  };

  renameFile() {
    let title = 'Rename Note';
    this.matDialog
      .open(CreateFileDialogComponent, {
        data: {
          type: 'Save',
          fileName: this.selectedFileToView.fileName,
          dialogTitle: title,
        },
        maxHeight: '90vh',
        width: '90vw',
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (value: any) => {
          if (value) {
            if (value.folderName === this.selectedFileToView.fileName) return;
            this.startProgressLoader();
            this.collaborationService
              .fileAction(
                {
                  contentId: this.selectedFileToView.id,
                  parentId: this.currentBreadcrumbId ?? null,
                  appId: this.fileAppID,
                  spaceId: this.fileSpaceID,
                  name: value.folderName + (this.selectedFileToView.fileExtension && ![FileTypes.NOTE, FileTypes.FOLDER].includes(this.selectedFileToView.kind) ? '.' + this.selectedFileToView.fileExtension : ''),
                  modifiedBy: this.loggedUser.id,
                },
                'renameFile'
              )
              .subscribe({
                next: (response: DocumentsSpace) => {
                  this.handleDocumentCreation(response);
                },
                error: (err: any) => {
                  this.handleDocumentCreation(
                    {},
                    'Error renaming the document. Please try again.',
                    true,
                    err
                  );
                },
              });
          }
        },
      });
  }

  deleteFile() {
    let deleteFilePaylod = {
      contentId: this.selectedFileToView.id,
      parentId: this.currentBreadcrumbId ?? null,
      appId: this.fileAppID,
      spaceId: this.fileSpaceID,
      name: this.selectedFileToView.name,
      modifiedBy: this.loggedUser.id,
    };
    this.startProgressLoader();
    this.collaborationService
      .fileAction(deleteFilePaylod, 'deleteFile')
      .subscribe((response: DocumentsSpace) => {
        this.handleDocumentCreation(response);
        const snackBarRef = this.snackBar.openFromComponent(SnackbarComponent, {
          panelClass: 'custom-snackbar',
          duration: 6000,
          data: {
            snackBar: this.snackBar,
            message: this.fileTypesDeleteMapper[this.selectedFileToView.kind]
              ? this.fileTypesDeleteMapper[this.selectedFileToView.kind] +
              ' was trashed.'
              : `Document was trashed.`,
            actionButton: {
              title: 'Undo',
            },
          },
        });
        snackBarRef.afterDismissed().subscribe({
          next: (res: any) => {
            if (res.dismissedByAction) {
              this.startProgressLoader();
              this.collaborationService
                .fileAction(deleteFilePaylod, 'undoFileDelete')
                .subscribe({
                  next: (response: DocumentsSpace) => {
                    this.handleDocumentCreation(response);
                    this.snackBar.openFromComponent(SnackbarComponent, {
                      panelClass: 'custom-snackbar',
                      duration: 6000,
                      data: {
                        snackBar: this.snackBar,
                        message: this.fileTypesDeleteMapper[
                          this.selectedFileToView.kind
                        ]
                          ? this.fileTypesDeleteMapper[
                          this.selectedFileToView.kind
                          ] + ' was restored.'
                          : `Document was restored.`,
                      },
                    });
                  },
                  error: (err: any) => {
                    this.handleDocumentCreation(
                      {},
                      'Error restoring the document. Please try again.',
                      true,
                      err
                    );
                  },
                });
            }
          },
          error: (err: any) => {
            this.handleDocumentCreation(
              {},
              'Error deleting the document. Please try again.',
              true,
              err
            );
          },
        });
      });
  }
  downloadOrOpenDocumentInDevice(action: any, url?: string) {
    if (url) {
      const a: HTMLAnchorElement = document.createElement(
        'a'
      ) as HTMLAnchorElement;
      a.href = url;
      a.download = `${action.name}${action.kind}`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      //window.open(url, "_blank")
    } else {
      this.startProgressLoader();
      this.getDocumentBlob(this.selectedFileToView, true);
    }
  }

  getDocumentBlob(element: any, isDownload?: boolean) {
    isDownload ? (this.startProgressLoader()) : (this.showLoader = true);
    let isOfcFile = [PreviewDocTypes.DOC, PreviewDocTypes.PPT, PreviewDocTypes.XLS].some((ext) =>
      element.fileExtension.includes(ext)
    );
    this.collaborationService
      .downloadDocument(
        element.blobId,
        {
          spaceId: this.fileSpaceID,
          appId: this.fileAppID,
          fileExtension: element.fileExtension,
        },
        isDownload || !isOfcFile ? 'downloadFile' : 'file-preview'
      )
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response], {
            type:
              isDownload ||
                element.kind === 'image' ||
                element.fileExtension === PreviewDocTypes.TXT
                ? element.blobMediaType
                : 'application/pdf',
          });
          const url = window.URL.createObjectURL(blob);
          if (isDownload) {
            const link = document.createElement('a');
            link.href = url;
            link.download = element.name;
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
            this.collaborationService.displaySuccessMessage(
              'File downloaded successfully.'
            );
            this.showProgress = false;
          } else {
            element.blobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              url + '#toolbar=0'
            );
            element.blob = blob;
            this.createObjectURL = url;
            if (element.fileExtension === PreviewDocTypes.MSG) {
              const msgBlob = new Blob([response], {
                type: 'application/vnd.ms-outlook',
              });
              const fileReader = new FileReader();
              fileReader.onload = (e: ProgressEvent): void => {
                const arrayBuffer: ArrayBuffer = (<any>e.target).result;

                const msgReader = new MsgReader.MSGReader(arrayBuffer);
                const msg: MSGFileData = msgReader.getFileData() as MSGFileData;
                element.emailContent = msg;
                element.emailContent.body =
                  this.sanitizer.bypassSecurityTrustHtml(
                    element.emailContent.body
                  );
                this.previewElement = element;
              };
              fileReader.readAsArrayBuffer(msgBlob);
            }
            else if (element.fileExtension === PreviewDocTypes.CSV) {
              const reader = new FileReader();
              let csvData;
              reader.onload = (event: ProgressEvent<FileReader>) => {
                csvData = event.target?.result as string;
                this.previewElement = { ...element, csvData };
              };
              reader.readAsText(blob);
            }
            else {
              this.previewElement = element;
            }
            this.showLoader = false;
          }
        },
        error: (err: any) => {
          if (isDownload) {
            this.collaborationService.displayErrorMessage(
              err,
              'Error downloading the file. Please try again.'
            );
            this.showProgress = false;
          } else {
            this.showLoader = false;
            if (this.weavyData.isMobileScreen) {
              this.collaborationService.displayErrorMessage(
                err,
                'Preview feature for this file is currently unavailable.'
              );
            }
            else {
              this.collaborationService.displayErrorMessage(
                {},
                'Preview feature for this file is currently unavailable. Please open the downloaded file to preview.',
                'warning-snackbar',
                4000,
                'warning'
              );
              this.getDocumentBlob(element, true);
            }
          }
        },
      });
  }

  previewDocument(element: any) {
    this.showLoader = true;
    this.collaborationService
      .downloadDocument(
        element.blobId,
        {
          spaceId: this.fileSpaceID,
          appId: this.fileAppID,
          fileExtension: element.fileExtension,
        },
        'file-viewer'
      )
      .subscribe({
        next: (response: any) => {
          // downloadDocument uses responseType: 'blob' (collaboration.service.ts), so response
          // is already a Blob. Pass it through directly — wrapping it in Uint8Array(blob)
          // produces an empty view and PDF.js reports "0 bytes".
          this.previewElement = { ...element, pdfBytes: response as Blob };
          this.showLoader = false;
        },
        error: (err: any) => {
          this.showLoader = false;
          if (this.weavyData?.isMobileScreen) {
            this.collaborationService.displayErrorMessage(
              err,
              'Preview feature for this file is currently unavailable.'
            );
          } else {
            this.collaborationService.displayErrorMessage(
              {},
              'Preview feature for this file is currently unavailable. Please open the downloaded file to preview.',
              'warning-snackbar',
              4000,
              'warning'
            );
            this.getDocumentBlob(element, true);
          }
        },
      });
  }

  fileDetails() {
    this.matDialog
      .open(FileDetailsDialogComponent, {
        data: { ...this.selectedFileToView, user: this.loggedUser },
        width: '90vw',
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (value: any) => {
          if (value) {
            this.followUnfollow();
          }
        },
      });
  }

  onBackdropClick() {
    this.fileCreateMenuOpened = false;
  }

  toggleFileCreateMenu() {
    this.fileCreateMenuOpened = !this.fileCreateMenuOpened;
  }

  createFolder(fieldType: any) {
    if (!this.fileTypes[fieldType]) {
      return;
    }
    const fileTypes = ['docx', 'xlsx', 'pptx'];
    const fileUrls: any = {
      docx: 'https://crm-collaboration-uat.chubb.com/DAV/u467.i3343.d8352cd6da27080b5e948bed77b6c373e97a0544/s17596/a31370/Library%20Flow.docx',
      xlsx: 'https://crm-collaboration-uat.chubb.com/DAV/u467.i3357.1f9fea0db7b40fe2cc0b0a3ea434d20fab28ae10/s17596/a31370/excel.xlsx',
      pptx: 'https://crm-collaboration-uat.chubb.com/DAV/u467.i3356.fb85ee18f327843b1425964e2ab25751899975c8/s17596/a31370/test.pptx',
    };
    this.matDialog
      .open(CreateFileDialogComponent, {
        data: {
          type: this.fileTypes[fieldType],
          title: 'New Word document',
          fileName: '',
          dialogTitle:
            fieldType !== 'folder' && this.fileTypesMapper[fieldType]
              ? this.fileTypesMapper[fieldType]['menuOptions'][0].dialogTitle
              : 'Create folder',
        },
        maxHeight: '90vh',
        width: '90vw',
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (value: any) => {
          if (value) {
            this.showLoader = true;
            if (fieldType === FileTypes.FOLDER) {
              let newFolder: any = this.addCommonFileDetails({
                name: value.folderName,
              });
              newFolder.type = 2;
              newFolder.kind = FileTypes.FOLDER;
              this.collaborationService
                .createDocument(
                  this.fileSpaceID,
                  this.fileAppID,
                  newFolder,
                  'Folder'
                )
                .subscribe({
                  next: (response: any) => {
                    this.handleDocumentCreation(
                      response,
                      'Folder created successfully.'
                    );
                  },
                  error: (err: any) => {
                    this.handleDocumentCreation(
                      {},
                      'Error creating folder. Please try again.',
                      true,
                      err
                    );
                  },
                });
            } else {
              let mimetypes: any = {
                docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
              };
              let emptyMsFileSizes: any = {
                docx: 12697,
                xlsx: 9153,
                pptx: 32768,
              };
              let newMSFile: any = this.addCommonFileDetails({
                name: value.folderName + this.fileTypes[fieldType],
                type: mimetypes[fieldType],
                size: emptyMsFileSizes[fieldType],
              });
              newMSFile.fileContent = Microsoft_Empty_Blob_Contents[fieldType];
              newMSFile.kind = this.extensionMapper[fieldType];
              newMSFile.fileExtension = fieldType;
              newMSFile.properties = JSON.stringify({ Description: '' });
              this.collaborationService
                .createDocument(this.fileSpaceID, this.fileAppID, newMSFile)
                .subscribe({
                  next: (response: any) => {
                    this.handleDocumentCreation(
                      response,
                      'Document created successfully.'
                    );
                  },
                  error: (err: any) => {
                    this.handleDocumentCreation(
                      {},
                      'Error creating document. Please try again.',
                      true,
                      err
                    );
                  },
                });
            }
          }
        },
      });
  }

  onDragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = true;
  }

  onDragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = false;
  }

  onFileDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = false;

    const files = event.dataTransfer.files;
    this.onFileChange(files, true);
  }

  resetFileInput() {
    if (this.fileUpload) {
      this.fileUpload.nativeElement.value = '';
    }
  }

  async onFileChange(files: FileList, isDropLoader?: boolean): Promise<void> {
    let fileSizeExceeded = Array.from(files).some((file: any) => file.size >= this.maxFileSize);
    if (fileSizeExceeded && files.length === 1) {
      this.matDialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Maximum Limit Exceeded',
          message: 'The uploaded document exceeds the maximum limit of 25MB. Please try uploading a smaller document.',
          buttonText: 'ok',
        },
        autoFocus: false,
      });
      this.resetFileInput();
      return;
    }
    //check if file already exists
    const { validFiles, duplicateFiles, hugeFiles } = this.checkDuplicatieFiles(this.dataSource.data, files);

    if (duplicateFiles.length) {
      const msg = duplicateFiles.length === 1 ? 'a file named ' + duplicateFiles[0].name : duplicateFiles.length + ' files with same name'
      this.collaborationService.displayErrorMessage(
        {},
        `The destination already has ${msg}. Please reupload in details section of files or re-name and upload again.`,
        'warning-snackbar',
        4000,
        'warning'
      );
    }

    if (hugeFiles.length && files.length) {
      let msg = hugeFiles.length === 1 ? 'The uploaded document ' + hugeFiles[0].name : hugeFiles.length + ' of the uploaded documents';
      this.matDialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Maximum Limit Exceeded',
          message: msg + ' exceeds the maximum limit of 40MB. Please try uploading a smaller document.',
          buttonText: 'ok',
        },
        autoFocus: false,
      });
    }

    if (!validFiles.length) {
      this.resetFileInput();
      return;
    }

    const totalFileSize = Array.from(validFiles).reduce((total, file) => total + file.size, 0);
    if (files.length > 1 && totalFileSize >= this.bulkFileSize) {
      this.startProgressLoader(false, 60);
      this.bulkUpload(validFiles);
      return;
    }
    let filesReqBody = [];
    this.startProgressLoader(false, 50);
    for (let i = 0; i < validFiles.length; i++) {
      const file = validFiles[i];
      filesReqBody.push(await this.getFilePayload(file));
      if (i === validFiles.length - 1) {
        validFiles.length > 1
          ? this.createFile(
            {
              files: filesReqBody,
              requestedBy: this.loggedUser.id,
              requestedAt: new Date(),
            },
            'Files'
          )
          : this.createFile(filesReqBody[0]);
      }
    }
    this.resetFileInput();
  }

  async getFilePayload(file: any) {
    const fileContent = await this.collaborationService.getBase64File(file);
    let lastDotIndex = file.name.lastIndexOf('.');
    let fileType =
      lastDotIndex === -1
        ? ''
        : file.name.substring(lastDotIndex + 1)?.toLowerCase();
    let newFile: any = this.addCommonFileDetails(file);
    newFile.fileContent = fileContent;
    newFile.kind = this.extensionMapper[fileType];
    newFile.fileExtension = fileType;
    newFile.properties = JSON.stringify({ Description: '' });
    return newFile;
  }

  async bulkUpload(files: File[]) {
    const sortedFiles = files.sort((a, b) => b.size - a.size);
    let fileBatches = this.getFileBatches(sortedFiles);
    let fileApiCalls = await Promise.all(fileBatches.map(async (batch: any) => {
      let filesReqBody = await Promise.all(batch.map(async (file) => await this.getFilePayload(file)));
      return this.collaborationService
        .createDocument(this.fileSpaceID, this.fileAppID, {
          files: filesReqBody,
          requestedBy: this.loggedUser.id,
          requestedAt: new Date(),
        }, 'Files').pipe(catchError(err => of([])))
    }));
    forkJoin(fileApiCalls).subscribe({
      next: (response: any) => {
        this.showProgress = false;
        this.handleDocumentCreation(
          {
            files: [...(response[0]?.files ?? []), ...(response[1]?.files ?? [])].filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.id === item.id
              ))
            )
          },
          'Files uploaded successfully.'
        );
      },
      error: (err: any) => {
        this.showProgress = false;
        this.handleDocumentCreation(
          {},
          'Error uploading the files. Please try again.',
          true,
          err
        );
      },
    });
    this.resetFileInput();
  }

  getFileBatches(files: File[]) {
    const batches: File[][] = [];
    let currentBatch: File[] = [];
    let currentSize = 0;
    Array.from(files).forEach(file => {
      const fileSize = file.size;

      if (currentSize + fileSize > this.bulkFileSize) {
        batches.push(currentBatch);
        currentBatch = [file];
        currentSize = fileSize;
      } else {
        currentBatch.push(file);
        currentSize += fileSize;
      }
    });

    if (currentBatch.length > 0) {
      batches.push(currentBatch);
    }
    return batches;
  }

  handleRowClick(row: any) {
    if (row.kind === this.fileTypes.folder) {
      this.breadcrumb.push({
        id: row.id,
        name: row.name,
      });
      this.currentBreadcrumbId = row.id;
      this.currentBreadcrumbTableData = row.children ?? [];
      this.filterTableData(row.children ?? []);
    }
    if (row.kind === FileTypes.NOTE) {
      this.createNote(row);
    }
    const isDoc = row.fileExtension.includes(PreviewDocTypes.DOC) && !excludedExtensions.includes(row.fileExtension);
    const isPpt = row.fileExtension.includes(PreviewDocTypes.PPT);
    const isXls = row.fileExtension.includes(PreviewDocTypes.XLS) && !excludedExtensions.includes(row.fileExtension);
    const isImage = row.kind === 'image';

    const isValidFile = isDoc || isPpt || isXls || isImage || allowedExtensions.includes(row.fileExtension);
    if (isValidFile) {
      // this.previewDocument(row);
      this.getDocumentBlob(row);
    } else {
      this.previewNotSupported(row);
    }
  }

  navigateBreadcrumb(item: any) {
    const index = this.breadcrumb.findIndex(
      (navItem: any) => navItem.id === item.id
    );
    if (index === -1) return;
    if (index === this.breadcrumb.length - 1) {
      return;
    } else {
      this.breadcrumb = this.breadcrumb.slice(0, index + 1);
      const navigatedItem = this.findFile(this.originalFilesData, item.id);
      this.currentBreadcrumbId = item.id;
      const data = navigatedItem ? navigatedItem.children : [];
      this.currentBreadcrumbTableData = data;
      this.filterTableData(data);
    }
  }

  resetBreadCrumb() {
    this.breadcrumb = [];
    this.currentBreadcrumbId = undefined;
    this.currentBreadcrumbTableData = undefined;
    this.filterTableData();
  }

  findFile(items: any, id: string): any {
    for (let item of items) {
      if (item.id === id) {
        return item;
      }
      if (item.children) {
        const found = this.findFile(item.children, id);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  }

  onPreviewClose() {
    window.URL.revokeObjectURL(this.createObjectURL);
    this.previewElement = null;
  }

  toggleView() {
    this.tableView = !this.tableView;
  }

  createNote(note?: any) {
    this.disableDragAndDrop = true;
    const dialogRef = this.matDialog.open(NoteComponent, {
      data: {
        dataSource: this.dataSource.data ?? [],
        appID: this.fileAppID,
        spaceID: this.fileSpaceID,
        parentID: this.currentBreadcrumbId,
        extensionMapper: this.extensionMapper,
        loggedUser: this.loggedUser,
        note,
      },
      panelClass: 'create-note-dialog',
    });
    dialogRef.afterClosed().subscribe({
      next: (value: any) => {
        this.disableDragAndDrop = false;
        if (value !== undefined) {
          if (value === 'error') {
            this.collaborationService.displayErrorMessage(
              '',
              `Failed to ${note ? 'updated' : 'create'} note. Please try again.`
            );
          } else {
            let data;
            if (note) {
              if (this.currentBreadcrumbId) {
                let currentObject = this.findCurrentBreadcrumbObject(
                  this.currentBreadcrumbId,
                  this.originalFilesData
                );
                currentObject.children = currentObject.children.map(
                  (item: IFile) => {
                    if (item.id === note.id) {
                      return value;
                    }
                    return item;
                  }
                );
                data = currentObject.children;
              } else {
                data = this.originalFilesData = this.originalFilesData.map(
                  (item: IFile) => {
                    if (item.id === note.id) {
                      return value;
                    }
                    return item;
                  }
                );
              }
              this.collaborationService.displaySuccessMessage(
                'Note updated successfully.'
              );
            } else {
              if (this.currentBreadcrumbId) {
                let currentObject = this.findCurrentBreadcrumbObject(
                  this.currentBreadcrumbId,
                  this.originalFilesData
                );
                currentObject.children = currentObject.children?.length
                  ? [...currentObject.children, value]
                  : [value];
                data = currentObject.children;
              } else {
                this.originalFilesData.push(value);
                data = this.originalFilesData;
              }
              this.collaborationService.displaySuccessMessage(
                'Note created successfully.'
              );
            }
            this.filterTableData(data);
          }
        }
      },
    });
  }

  handelAllTopicEvents(topicEvents: any) {
    switch (topicEvents.type) {
      case 'allDocuments':
        this.originalFilesData = JSON.parse(topicEvents.result.body);
        this.filterTableData();
        this.showLoader = false;
        this.progressVal = 100;
        this.showProgress = false;
        break;
    }
  }

  startProgressLoader(stopAutomatically?: boolean, inter?: number) {
    this.progressVal = 1;
    this.showProgress = true;

    interval(inter ?? 40)
      .pipe(takeWhile(() => this.progressVal <= 100))
      .subscribe({
        next: () => {
          if (this.progressVal === 100 && stopAutomatically) {
            this.showProgress = false;
          }
          this.progressVal++;
        },
      });
  }

  getDocumentsList(refreshDocuments = false) {
    this.showLoader = true;
    if (!refreshDocuments) {
      this.initiateRequiredAppsSpaces();
    }
    const objForInitializeCall = this.collaborationService.getObjForInitializeCall(this.weavyData);
    this.collaborationService.initDocuments({ ...objForInitializeCall, tab: this.docType }, refreshDocuments).subscribe({
      next: (res: DocumentsSpace) => {
        this.collaborationService.additionalDataPulledInTabs[objForInitializeCall.appKey] = res;
        this.collaborationService.allDocumentsList = uniq([...this.collaborationService.allDocumentsList, ...res.files]);
        this.collaborationService.allDocumentsList.forEach((file: any) => {
          file.label = file.name;
          file.value = file.name;
        });
        this.appName = res.appName;
        if (!this.weavyData?.isIhubScreen && this.appName) {
          this.displayName = this.weavyData.draft ? `Draft~${this.appName}` : (this.appName ?? 'Other-Files');
        }
        this.documentSpaceDetails = res;
        // this.appActionsList[this.appActionsList.length - 2] = this.documentSpaceDetails.appFollowed ? this.subscribeActions.unsubscribe : this.subscribeActions.subscribe;
        this.collaborationService.spaceId = this.fileSpaceID = res.spaceId;
        this.fileAppID = res.appId;
        this.originalFilesData = res.files?.length > 0 ? this.flattenExtensions(res?.files) : [];
        this.filterTableData()
        this.loggedUser = res.user;
        this.showLoader = false;
      },
      error: (err: any) => {
        this.isUserUnAuthorized = true;
        this.errorStatusCode = err.status;
        this.originalFilesData = [];
        this.filterTableData()
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error while retrieving documents. Please try after some time.');
      }
    });
  }

  initiateRequiredAppsSpaces() {
    if (this.weavyData.postCommentsObj) {
      const objForInitializeCall = this.collaborationService.getObjForInitializeCall(this.weavyData.postCommentsObj);
      this.collaborationService.initializePosts(objForInitializeCall).subscribe({
        next: (response: PostsSpace) => {
          this.collaborationService.allPostSpaceDetails = response;
          this.collaborationService.additionalDataPulledInTabs[objForInitializeCall.appKey] = response;
        },
        error: (err: any) => {
          this.isUserUnAuthorized = true;
          this.errorStatusCode = err.status;
          this.collaborationService.displayErrorMessage(err, 'Error while retrieving documents. Please try after some time.');
        }
      })

    }
    if (this.weavyData.referralDocumentsObj) {
      const objForInitializeCall = this.collaborationService.getObjForInitializeCall(this.weavyData.referralDocumentsObj);
      this.collaborationService.initDocuments({ ...objForInitializeCall, tab: "referral" }).subscribe({
        next: (res: DocumentsSpace) => {
          this.collaborationService.additionalDataPulledInTabs[objForInitializeCall.appKey] = res;
        },
        error: (err: any) => {
          this.isUserUnAuthorized = true;
          this.errorStatusCode = err.status;
          this.collaborationService.displayErrorMessage(err, 'Error while retrieving documents. Please try after some time.');
        }
      })
    }

    if (this.weavyData.policyDocumentsObj) {
      this.showLoader = true;
      const objForInitializeCall = this.collaborationService.getObjForInitializeCall(this.weavyData.policyDocumentsObj);
      this.collaborationService.initDocuments({ ...objForInitializeCall, tab: "policy" }).subscribe({
        next: (res: DocumentsSpace) => {
          this.collaborationService.additionalDataPulledInTabs[objForInitializeCall.appKey] = res;
          this.showLoader = false;
        },
        error: (err: any) => {
          this.isUserUnAuthorized = true;
          this.errorStatusCode = err.status;
          this.showLoader = false;
          this.collaborationService.displayErrorMessage(err, 'Error while retrieving documents. Please try after some time.');
        }
      })
    }
  }

  flattenExtensions(data: any) {
    return data.map((record: any) => {
      let lastDotIndex = record.name.lastIndexOf('.');
      record.fileName =
        lastDotIndex === -1
          ? record.name
          : record.name.substring(0, lastDotIndex);
      record.fileExtension = [FileTypes.FOLDER, FileTypes.NOTE].includes(
        record.kind
      )
        ? record.kind
        : lastDotIndex === -1
          ? record.kind
          : record.name.substring(lastDotIndex + 1)?.toLowerCase();
      if (record.kind === FileTypes.FOLDER && record.children?.length > 0) {
        record.children = this.flattenExtensions(record.children);
      }
      return record;
    });
  }

  createFile(reqBody: any, fileType?: string) {
    this.collaborationService
      .createDocument(this.fileSpaceID, this.fileAppID, reqBody, fileType)
      .subscribe({
        next: (response: any) => {
          this.showProgress = false;
          this.handleDocumentCreation(
            response,
            (fileType ? fileType : 'File') + ' uploaded successfully.'
          );
        },
        error: (err: any) => {
          this.showProgress = false;
          this.handleDocumentCreation(
            {},
            'Error uploading the file' +
            (fileType ? 's' : '') +
            '. Please try again.',
            true,
            err
          );
        },
      });
  }

  findCurrentBreadcrumbObject(id: any, data: any): any {
    for (const item of data) {
      if (item.id === id) {
        return item;
      }
      if (item.children) {
        let foundInChildren = this.findCurrentBreadcrumbObject(
          id,
          item.children
        );
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
  }

  handleDocumentCreation(
    response: any,
    msg?: string,
    isError = false,
    err = ''
  ) {
    this.showLoader = false;
    this.showProgress = false;
    if (msg) {
      isError
        ? this.collaborationService.displayErrorMessage(err, msg)
        : this.collaborationService.displaySuccessMessage(msg);
    }
    let data;
    if (!isError && response?.files?.length >= 0) {
      this.originalFilesData = this.flattenExtensions(response.files);
      if (this.currentBreadcrumbId) {
        let currentObject = this.findCurrentBreadcrumbObject(
          this.currentBreadcrumbId,
          this.originalFilesData
        );
        data = currentObject?.children || [];
      } else {
        data = this.originalFilesData;
      }
      this.filterTableData(data);
    }
  }

  addCommonFileDetails(file: any) {
    return {
      parentId: this.currentBreadcrumbId ?? null,
      appId: this.fileAppID,
      spaceId: this.fileSpaceID,
      name: file.name,
      createdAt: new Date().toISOString(),
      modifiedAt: new Date().toISOString(),
      createdBy: this.loggedUser.id,
      modifiedBy: this.loggedUser.id,
      isDraft: 0,
      blobName: file.name,
      blobMediaType: file.type,
      blobSize: file.size,
      blobCreatedAt: new Date().toISOString(),
      blobCreatedBy: this.loggedUser.id,
    };
  }

  followUnfollow(isApp?: boolean) {
    this.collaborationService
      .likeOrFollow(
        {
          entityTypeId: isApp ? 1 : 17,
          entityId: isApp ? this.fileAppID : this.selectedFileToView.id,
          userId: this.loggedUser.id,
          requestType: 'follow',
        },
        'follow'
      )
      .subscribe({
        next: (response: any) => {
          if (isApp) {
            this.documentSpaceDetails.appFollowed =
              !this.documentSpaceDetails.appFollowed;
            //this.appActionsList[this.appActionsList.length - 2] = this.documentSpaceDetails.appFollowed ? this.subscribeActions.unsubscribe : this.subscribeActions.subscribe;
          } else
            this.selectedFileToView.contentFollowed =
              !this.selectedFileToView.contentFollowed;
        },
        error: (err: any) => {
          this.collaborationService.displayErrorMessage(
            err,
            'Network error. Please try after some time.'
          );
        },
      });
  }

  filterTableData(data: any[] = this.originalFilesData) {
    const fieldName = this.sortOrderDetail.filedName;
    const sortOrder = this.sortOrderDetail.sortOrder;
    if (data.length > 0 && fieldName && sortOrder) {
      if (fieldName.includes('size')) {
        this.dataSource.data = orderBy(
          data,
          (field) =>
            !field[fieldName] || field[fieldName] === '' ? 0 : field[fieldName],
          sortOrder
        );
      } else if (fieldName.includes('date')) {
        this.dataSource.data = orderBy(
          data,
          (field) =>
            field[fieldName] === '' ? new Date() : new Date(field[fieldName]),
          sortOrder
        );
      } else {
        this.dataSource.data = orderBy(
          data,
          (field) =>
            !field[fieldName] || field[fieldName] === ''
              ? ' '
              : field[fieldName],
          sortOrder
        );
      }
    } else {
      this.dataSource.data = data;
    }
  }

  sortTableData(column: string) {
    if (this.sortOrderDetail.filedName === this.columnMapper[column]) {
      if (this.sortOrderDetail.sortOrder === 'desc') {
        this.sortOrderDetail.sortOrder = null;
        this.filterTableData(
          this.currentBreadcrumbId
            ? this.currentBreadcrumbTableData
            : this.originalFilesData
        );
        return;
      }
      this.sortOrderDetail.sortOrder =
        this.sortOrderDetail.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortOrderDetail = {
        filedName: this.columnMapper[column],
        sortOrder: 'asc',
      };
    }
    this.filterTableData(this.dataSource.data);
  }

  handleModuleRowClick(item: any) {
    this.handleRowClick(item);
    // Legacy: card view used to fire a second preview call here, duplicating handleRowClick's
    // call for valid files and overriding the previewNotSupported route for excluded extensions
    // (docm/xlsm/xlx). Removed to match table-view behavior and stop double API calls.
    const validExtensions = [PreviewDocTypes.DOC, PreviewDocTypes.PPT, PreviewDocTypes.XLS, PreviewDocTypes.PDF];
    if (
      validExtensions.some((ext) => item.fileExtension.includes(ext)) ||
      item.kind === 'image'
    ) {
      this.getDocumentBlob(item);
    }
  }

  notificationSettings() {
 
    (window as any).dataLayer.push({
      event: "referral_link_click",
      eventLabel: "Notification Settings",
      tabName: this.docType === 'referral' ? 'Referral Documents' : 'Policy Documents',
      eventPage: "Referral Actions",
    });
    this.collaborationService.setShowOrHideSideNav(this.docType, true);
  }

  downloadPosts() {
    this.showLoader = true;
    this.collaborationService.downloadPosts().subscribe({
      next: (res: any) => {
        this.collaborationService.doDownload(
          `${this.weavyData.appName}-posts`,
          'application/pdf',
          res
        );
        this.showLoader = false;
        (window as any).dataLayer.push({
          event: "referral_file_download",
          eventLabel: "Download Posts",
          fileName: `${this.weavyData.appName}-posts.pdf`,
          tabName: this.docType === 'referral' ? 'Referral Documents' : 'Policy Documents',
          eventPage: "Referral Actions",
        });
      },
      error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(
          err,
          'Error while downloading the posts. Please try after some time.'
        );
      },
    });
  }

  downloadPostsAndPolicyDocs() {
    this.downloadAdditionalDocsInput.emit(true);
    if (this.weavyData.isIhubScreen) {
      this.downloadPostsAndPolicyDocsIhub();
    } else {
      this.downloadPostsAndPolicyDocsReferral();
    }
  }

  downloadPostsAndPolicyDocsReferral() {
    this.showLoader = true;
    this.collaborationService.getActivityId(this.weavyData.trackerReferenceNumber).subscribe({
      next: (res) => {
        if (res.data) {
          const payload: any = {
            activityIds: res.data.referralDocumentIds.join()
          }
          if (res.data.dynamicsPolicyTermId) {
            payload["hubPolicyTermId"] = res.data.dynamicsPolicyTermId;
          }
          this.collaborationService.downloadPostsAndPolicyDocsReferral(this.weavyData.trackerReferenceNumber, payload)
            .subscribe({
              next: (res: any) => {
                this.showLoader = false;
                const fileName = this.weavyData.spaceName;
                const dataType = "application/zip"
                this.collaborationService.doDownload(fileName, dataType, res);
           
                (window as any).dataLayer.push({
                  event: "referral_link_click",
                  eventLabel: 'Download Policy Docs & Posts',
                  tabName: this.docType === 'referral' ? 'Referral Documents' : 'Policy Documents',
                  eventPage: "Referral Actions",
                });
              },
              error: (err: any) => {
                this.showLoader = false;
                this.collaborationService.displayErrorMessage(err, 'Error while downloading the policy docs and posts. Please try after some time.');
              }
            })

        }
      },
      error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error while getting the activity docs. Please try after some time.');
      }
    });
  }

  downloadPostsAndPolicyDocsIhub() {
    this.showLoader = true;
    this.collaborationService.downloadPostsAndPolicyDocsIhub(this.weavyData.spaceKey)
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          const fileName = this.weavyData.spaceName;
          const dataType = "application/zip"
          this.collaborationService.doDownload(fileName, dataType, res);

          (window as any).dataLayer.push({
            event: "referral_link_click",
            eventLabel: 'Download All',
            tabName: this.docType === 'referral' ? 'Referral Documents' : 'Policy Documents',
            eventPage: "Referral Actions",
          });
        },
        error: (err: any) => {
          this.showLoader = false;
          this.collaborationService.displayErrorMessage(err, 'Error while downloading the Files. Please try after some time.');
        }
      })
  }

  downloadAllFiles() {
    this.showLoader = true;
    this.collaborationService
      .downloadAllFiles(this.documentSpaceDetails.appId)
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          const fileName = this.weavyData.appName;
          const dataType = 'application/zip';
          this.collaborationService.doDownload(fileName, dataType, res);
        },
        error: (err: any) => {
          this.showLoader = false;
          this.collaborationService.displayErrorMessage(
            err,
            'Error while downloading the Files. Please try after some time.'
          );
        },
      });
  }

  handleDocumentRefresh() {

    (window as any).dataLayer.push({
      event: "referral_link_click",
      eventLabel: "Refresh Documents",
      tabName: this.docType === 'referral' ? 'Referral Documents' : 'Policy Documents',
      eventPage: "Referral Actions",
    });
    this.breadcrumb = [];
    this.currentBreadcrumbId = undefined;
    this.currentBreadcrumbTableData = undefined;
    this.getDocumentsList(true);
  }

  previewNotSupported(element) {
    if ([FileTypes.NOTE, FileTypes.FOLDER].includes(element.kind)) return;
    if (this.weavyData?.isMobileScreen) {
      this.collaborationService.displayErrorMessage(
        {},
        'Preview for this file type is not supported.',
        'warning-snackbar',
        4000,
        'warning'
      );
      return;
    }
    this.collaborationService.displayErrorMessage(
      {},
      'Preview for this file type is not supported. Please open the downloaded file to preview.',
      'warning-snackbar',
      4000,
      'warning'
    );
    this.getDocumentBlob(element, true);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.collaborationService.additionalDataPulledInTabs = {};
  }

  checkDuplicatieFiles(existingFiles, newFiles) {
    const duplicateFiles = [];
    const validFiles = [];
    const hugeFiles = [];

    for (const file of newFiles) {
      if (existingFiles.some((exf: any) => exf.name.toLowerCase() === file.name.toLowerCase())) {
        duplicateFiles.push(file);
      }
      else {
        if (file.size >= this.bulkFileSize) {
          hugeFiles.push(file);
        }
        else
          validFiles.push(file);
      }
    }

    return {
      validFiles,
      duplicateFiles,
      hugeFiles
    };
  }
}